import React from 'react';
import { isArketBrand } from "@pb/utils/brandConfig";
import IconWrapper from '../IconWrapper';
const ChevronLeftIcon = (props) => isArketBrand ? (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "-4 -2 24 24" }),
    React.createElement("path", { d: "M0.210481 10.0372L10.0563 -7.57587e-08L11.7894 1.85874L3.71366 10.0372L11.7894 18.1413L10.13 20L0.210481 10.0372Z" }))) : (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M4.002 6v10.997L15 16.998v1l-10.998-.001V18h-1v-.003L3 17.998v-1l.002-.001V6h1z", transform: "rotate(45 11 18)" })));
export default ChevronLeftIcon;
//# sourceMappingURL=ChevronLeftIcon.js.map